module.exports = __webpack_public_path__ + "img/big_11B04_red.a1c32590.png";